import { render, staticRenderFns } from "./culturalTour.vue?vue&type=template&id=cc019cc2&scoped=true&"
import script from "./culturalTour.vue?vue&type=script&setup=true&lang=js&"
export * from "./culturalTour.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./culturalTour.vue?vue&type=style&index=0&id=cc019cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc019cc2",
  null
  
)

export default component.exports